export enum SubscriberStatusEnum {
    Approved = "Approved",
    PendingApproval = "Pending Approval",
    Rejected = "Rejected",
  }